import { signal } from "@angular/core";
import { JsonConvert } from "json2typescript";
import { BehaviorSubject, Observable } from "rxjs";

import { Basket, BasketItem } from "@hermes/api-model-basket";
import { EcomErrorCodes } from "@hermes/utils-generic-constants";

import { EcomError } from "../models/basket-feature.model";

export const BASKET_ITEM = {
    name: "productName",
    sku: "productSku",
    unitPrice: 98,
    departmentCode: "departementCode",
    familyCode: "familyCode",
    productCode: "productCode",
    divisionCode: "divisionCode",
    size: "",
    qty: 1,
} as BasketItem;

export const BASKET_ITEM_ENGRAVING = {
    ...BASKET_ITEM,
    customOptions: { engraving: ["LIGNE 1"] },
} as BasketItem;

const mockBasket = new JsonConvert().deserializeObject(
    {
        subtotal: 1344,
        grand_total: 1344,
        tax_amount: 224,
        shipping_amount: 0,
        items: [
            {
                sku: "P030026P",
                name: "Plat rond creux Bleus d'Ailleurs",
                image: "//assets.hermes.com/is/image/hermesproduct/030026P_set?a=a",
                unit_price: 336,
                final_price: 1344,
                prop65: false,
                excluded_material: false,
                qty: 4,
                stock: {
                    is_empty: false,
                    is_equals_to_qty: false,
                    is_less_than_qty: false,
                },
                has_error: null,
                max_sale_qty: 10_000,
                qty_increments: 1,
                shipping_information:
                    "Certains articles d’Art de la Table peuvent faire l’objet de délais de livraison supplémentaires. Si tel devait être le cas notre Service Client vous contactera pour vous informer du temps nécessaire à la réception de votre commande.",
                display_single_line: false,
                department_code: "P",
                family_code: "P10",
                product_code: "P123",
                division_code: "05",
                color_code: "",
                is_fake_qty: true,
                url: "/product/P030026P",
                options: { perso_info: "color: red" },
            },
        ],
        gift: null as unknown as Record<string, unknown>,
        has_sample: false,
        has_family_code: false,
        sample_skus: [],
        has_product_threshold: false,
        shipping_address: { is_webtoshop: false },
        billing_address: { country_id: "US" },
        shipping_method: null as unknown as string,
        shipping_method_label: "",
        default_shipping_method: null as unknown as string,
        shipping_duration: null as unknown as string,
        available_shipping_methods: {},
        shipping_appointment_timeslots: {},
        estimate_tax_error: false,
        show_tax: { ca_en: 1 },
        show_tax_message: null as unknown as Record<string, string>,
        has_casper: true,
        has_recurring: false,
        show_message: 0,
        shipping_appointment_dates: null,
        has_complimentary_delivery: false,
        adyen_client_key: "test_HAYFWEH7HFFTZJZHN6V6EIYX4Q4VZGVG",
        checkout_com_key: "pk_test_05711c93-68e4-49c8-b3f3-1d0983fa3e37",
        is_personalized: false,
        taxes_covered: 0,
        total_items: 4,
    },
    Basket,
);

export class BasketFacadeMock {
    public cart$: Observable<Basket> = new BehaviorSubject<Basket>(mockBasket);
    public error$ = new BehaviorSubject<{
        hasError: boolean;
        ecomError: EcomError;
    }>({
        hasError: false,
        ecomError: {
            internal_code: undefined as unknown as EcomErrorCodes,
        },
    });
    public pending$: Observable<boolean> = new BehaviorSubject<boolean>(false);
    public basket = signal(new Basket());

    public addToCart = () => {};
    public resetCart = () => {};
    public removeFromCart = () => {};
    public setBasket = () => {};
    public setCartItem = () => {};
    public clearData = () => {};
    public updateBasket = () => {};
    public appointmentTimeslotDates = () => [];

    constructor(value?: Partial<Basket>) {
        if (value) {
            const basket = new Basket(value);
            this.cart$ = new BehaviorSubject<Basket>(basket);
            this.basket.set(basket);
        }
    }

    /**
     * return the deserialized basket
     * @param : basket : the serialized basket to convert
     */
    public deserializeBasket = (basket: Basket): Basket => basket;
}
